import { Component, OnInit, ElementRef, ViewChildren, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { KhoKiemkekhoService } from '../phieu-kiem-ke-service/phieu-kiem-ke.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { ChiTietPhieuKiemKe, PhieuKiemKe } from '../phieu-kiem-ke-model/phieu-kiem-ke.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { DeNghiNhapKhoChiTiet } from '../../phieu-thong-tin-hang-ve-ver2/phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import moment from 'moment';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
// import { DeNghiNhapKhoChiTiet } from '../../kho-phieu-thong-tin-hang-ve/phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
//Component

@Component({
	selector: 'm-phieu-kiem-ke-detail',
	templateUrl: './phieu-kiem-ke-detail.component.html',
	styleUrls: ['../phieu-kiem-ke.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class PhieuKiemKeDetailComponent implements OnInit {

	/* Các trường focus cho các tag trong form */
	@ViewChildren('focus') focus;

    /* Comment columns mat-table
    Các trường columns cho bảng:
    - displayedColumns: display ra form
    - availableColumns: các cột sẽ được add vào display.
    - extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QuyCach',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'TenDVT',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'Solo',
			displayName: 'Số lô',
			alwaysChecked: false,
			isShow: true
		},
		//{
		//	stt: 6,
		//	name: 'IdKho',
		//	displayName: 'Kho',
		//	alwaysChecked: false,
		//	isShow: true
		//},
		{
			stt: 7,
			name: 'ViTriKho',
			displayName: 'Vị trí kho',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'MaPallet',
			displayName: 'MaPallet',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'SoMay',
			displayName: 'Số máy',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: "MaThung",
			displayName: "Mã thùng (TP)",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "SoMeSoXe",
			displayName: "Số mẻ/số xẻ",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: 'MaSub',
			displayName: 'Mã sub',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 7,
			name: 'NgayNhap',
			displayName: 'Ngày nhập',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 7,
			name: 'ChoPhepXuatKho',
			displayName: 'Cho phép xuất kho',
			alwaysChecked: false,
			isShow: true
		},
		//{
		//	stt: 8,
		//	name: 'Tinhtrang',
		//	displayName: 'Đóng băng hàng',
		//	alwaysChecked: false,
		//	isShow: true
		//},
		{
			stt: 9,
			name: 'Soluongphanmem',
			displayName: 'SL tồn hệ thống',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'Soluongthucte',
			displayName: 'SL tồn thực tế',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'Chenhlech',
			displayName: 'Chênh lệch',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'LyDoChenhLech',
			displayName: 'Lý do chênh lệch',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'HuongXuLy',
			displayName: 'Hướng xử lý',
			alwaysChecked: false,
			isShow: true
		}

	];
	sumColums: string[] = ['#', 'Soluongphanmem', 'Soluongthucte', 'Chenhlech'];

	/* Danh sách trạng thái */
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChiTietPhieuKiemKe>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	viewLoading: boolean = false;   	// Loading khi mở dialog
	listNguoiThucHien: string[] = [];   // Array lưu id người thực hiện
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	Form: FormGroup;				        //Form thông tin kiểm kê
	hasFormErrors: boolean = false;

	DuyetForm: FormGroup;			            //Form add hàng hóa cho phiếu
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	Item: PhieuKiemKe;

	/* Danh sách tạm chi tiết hàng hóa của phiếu kiểm kê */
	tmpChiTiet: ChiTietPhieuKiemKe[] = [];

	/* Danh sách tạm chi tiết đề nghị kiểm kê để so sánh khi nhập số lượng trên lưới */
	// deNghiNhapKhoResult: DeNghiNhapKhoChiTiet[] = [];
	listKho: any[] = [];
	/*Config Form */
	CONFIG: CommonConFig;
	constructor(
		public dialogRef: MatDialogRef<PhieuKiemKeDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private service: KhoKiemkekhoService,
		private FB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
	) {
		this.dialogRef.disableClose = true;
	}

	/** LOAD DATA */
	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.viewLoading = true;
		this.service.listKho().subscribe(res => {
			if (res && res.status === 1) {
				this.listKho = res.data;
			} else
				this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetect.detectChanges();
		});
		this.Item = new PhieuKiemKe();
		this.Item.clear();
		/*Load all dropdown and create form */
		this.ListState();
		this.createForm();
		if (this.data.IdKk > 0) {
			this.service.getChiTietKhoKiemkekho(this.data.IdKk).subscribe(res => {
				this.viewLoading = false;
				if (res && res.status == 1) {
					this.Item = res.data;
					this.createForm();
					this.checkState();
				} else
					this.layoutUtilsService.showErorr(res.error.message);
				this.changeDetect.detectChanges();
			})
		}
		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetect.detectChanges();
		});

		this.availableColumns = this.availableColumns;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
	}

	/*Create Form with appropriate sub forms */
	createForm() {
		let listName = '';
		if (this.Item.listNguoiThucHien) {
			this.Item.listNguoiThucHien.forEach(element => {
				listName += element.TenNguoiThucHien + ', ';
			})
		}
		listName = listName.substring(0, listName.length - 2);

		/*Group các Form */
		var date = new Date();
		if (this.Item.Ngaykk)
			date = moment(this.Item.Ngaykk).toDate()
		this.Form = this.FB.group({
			SoPhieu: [this.Item.Sophieu, Validators.required],
			NgayLapPhieu: [this.Item.Ngaytao, Validators.required],
			TenNguoiLap: [this.Item.TenNguoitao],
			TrangThai: [this.nameState],
			IdKho: [this.Item.IdKho + '', Validators.required],
			Ngaykk: [date, Validators.required],
			DSNguoiThucHien: [listName, Validators.required],
			//Diengiai: [this.Item.Diengiai]
		});
		/*Disable các trường dữ liệu không thay đổi */
		this.Form.disable();
		/*------------------------------------------------------------------*/

		//this.DuyetForm = this.DuyetFB.group({
		//	Thukhoxacnhan: [(this.Item.Thukhoxacnhan != null && this.Item.Thukhoxacnhan > 0) ? this.Item.TenThukhoxacnhan : ''],
		//	NgayXacNhan: [!(this.Item.Ngayxacnhan == undefined || this.Item.Ngayxacnhan == '') ? this.getFormatDate(this.Item.Ngayxacnhan) : '' ],
		//})
		///*Disable các trường dữ liệu không thay đổi */
		//this.DuyetForm.disable();
		/*------------------------------------------------------------------*/

		/*Add dữ liệu chi tiết*/
		if (this.Item.listChiTietKhoKiemkekho && this.Item.listChiTietKhoKiemkekho.length > 0) {
			this.tmpChiTiet = this.Item.listChiTietKhoKiemkekho.map(x => {
				return Object.assign({}, x);
			});
			this.tmpChiTiet = [...this.tmpChiTiet];
		}

		this.changeDetect.detectChanges();
	}

	/*Hàm thông báo lỗi cho form tương ứng */
	onAlertFormClose($event) {
		this.hasFormErrors = false;
	}
	/*---------------------------------------- */
	open_page_nk(id: number) {
		const url = `/nhap-kho/chi-tiet/${id}`;
		window.open(url, '_blank');
	}
	open_page_xk(id: number) {
		const url = `/xuat-kho/chi-tiet/${id}`;
		window.open(url, '_blank');
	}
	/*Lấy tiêu đề cho dialog*/
	getTitle(): string {
		return `Chi tiết phiếu kiểm kê`;
	}
	getTotalNumber(){
		let total = 0;
		this.tmpChiTiet.forEach(element => {
		total += Number(element.Soluongphanmem)
		});
		return total.toFixed(5);
	}
	getTotalNumber2(){
		let total = 0;
		this.tmpChiTiet.forEach(element => {
			total += Number(element.Soluongthucte)
		});
		return total.toFixed(5);
	}
	getTotalNumber3(){
		let total = 0;
		this.tmpChiTiet.forEach(element => {
			total += Number(element.Soluongthucte) - Number(element.Soluongphanmem);
			
		});
		return total.toFixed(5);
	}
	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Hàm lấy danh sách trạng thái phiếu*/
	ListState() {
		this.service.listState().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetect.detectChanges();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.Item.Tinhtrang) {
				this.nameState = element.Description;
				if (this.Form != null)
					this.Form.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}
	/*---------------------------------------- */

	/*Hàm hỗ trợ format các dạng số trên form*/
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == '.') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == '.') {
					count += 1;
				}
			}
		}
		;
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	lpad(value, padding) {
		var zeroes = new Array(padding + 1).join("0");
		return (zeroes + value).slice(-padding);
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		var re = ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
		return re;
	}
	/*------------------------------------------------------------- */

	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back() {
		this.dialogRef.close(
			{
				isChange: false,		//Dữ liệu có thay đổi hay không?
			}
		);
	}
	/*------------------------------------------------------------- */

	/*
		Hàm hỗ trợ tổ hợp phím trên form
	*/
	onKeydownMain(event: KeyboardEvent) {
		//Tham khảo keyCode của event theo link: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
	}
	focusEvent() {
		if (this.focus != null && this.focus != undefined) {
			setTimeout(() => this.focus.first.nativeElement.focus(), 500);
			this.changeDetect.detectChanges();
		}
	}
	/*------------------------------------------------------------- */
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}

	formatNumberV2(item: string){
		if(item == '' || item == null || item == undefined)	return '0';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}

	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}

	getChenhLech(item: ChiTietPhieuKiemKe){
		var chenhlech = item.Soluongthucte - item.Soluongphanmem;
		return this.f_number(chenhlech);
	}

	
	getFormatDate_V2(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1 $7:$9:$11") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1 ");
		}
		return '';
	}

	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}

	f_isNaN(item: any){
		console.log(item);
		return isNaN(Number(item));
	}
	
}
